<template>
  <section class="filters">
    <div class="filters__select">
      <v-select
        v-if="materials"
        ref="materials"
        :options="materials"
        :clearable="false"
        :searchable="false"
        v-model="activeMaterial">
      </v-select>
    </div>
    <div class="filters__select">
      <v-select
        v-if="process"
        ref="process"
        :options="process"
        :clearable="false"
        :searchable="false"
        :placeholder="'Process'"
        v-model="activeProcess">
        <slot name="selected-option" v-bind="(activeProcess) ? activeProcess : 'Filter by process'"></slot>
      </v-select>
    </div>
    <div class="filters__select">
      <v-select
        v-if="types"
        ref="types"
        :options="types"
        :clearable="false"
        :searchable="false"
        :placeholder="'Types'"
        v-model="activeType">
        <slot name="selected-option" v-bind="(activeType) ? activeType : 'Filter by type'"></slot>
      </v-select>
    </div>
  </section>
</template>

<script>
import DataService from '@/services/data-service'
import vSelect from 'vue-select'

export default {
  name: 'Filters',
  components: {
    vSelect
  },
  data() {
    return {
      materials: [],
      types: [],
      process: [],
      activeMaterial: 'All materials',
      activeType: 'All types',
      activeProcess: 'All process'
    }
  },
  watch: {
    activeMaterial: function(material) {
      this.$emit('filterBy', 'material', material)
    },
    activeProcess: function(process) {
      this.$emit('filterBy', 'process', process)
    },
    activeType: function(type) {
      this.$emit('filterBy', 'type', type)
    }
  },
  async created() {
    // Years, get years from server, add all years, filter out duplicates
    this.materials = await this.getFilter('Material')

    this.materials.splice(0, 0, 'All materials')

    this.materials = [...new Set(this.materials)]

    this.$refs.materials.$refs.selectedOptions.addEventListener('mousedown', () => {
      if (this.$refs.materials.open) {
        this.toggleSelect(this.$refs.materials)
      }
    })

    // Types, get types from server, add all types, filter out duplicates
    this.types = await this.getFilter('type')

    this.types.splice(0, 0, 'All types')

    this.types = [...new Set(this.types)]

    this.$refs.types.$refs.selectedOptions.addEventListener('mousedown', () => {
      if (this.$refs.types.open) {
        this.toggleSelect(this.$refs.types)
      }
    })

    // Subjects, get subjects from server, add all subjects, filter out duplicates
    this.process = await this.getFilter('process')

    this.process.splice(0, 0, 'All process')

    this.process = [...new Set(this.process)]

    this.$refs.process.$refs.selectedOptions.addEventListener('mousedown', () => {
      if (this.$refs.process.open) {
        this.toggleSelect(this.$refs.process)
      }
    })
  },
  methods: {
    getFilter(filter) {
      return new Promise(resolve => {
        DataService
          .getData({ action: 'get_filter', filter: filter })
          .then(response => {
            resolve(response)
          })
      })
    },
    toggleSelect(select) {
      setTimeout(() => {
        select.open = false
      }, 20)
    }
  }
}
</script>

<style lang="scss" scoped>

.filters {
  @import "./node_modules/vue-select/src/scss/vue-select.scss";
  margin: 0 0 10px 0 !important;
  display:flex;
  flex-wrap: wrap;

  &__select {
    width: calc(33.3% - ((10px * 2) / 3));
    margin-right: 10px;

    &:nth-child(3n) {
      margin-right: 0px;
    }
  }
  /deep/ .v-select {
    position:relative;
    appearance: none;
    padding: 0.25rem;
    text-indent: 0.25rem;
    border: 1px solid #000;
    border-radius: 0px;
    background: #000;
    color: #fff;
    font-size: 1.5rem;
    font-family: $font--base;
    font-weight: bold;
    cursor: pointer;

    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      right:8px;
      top:19px;
      transform: translateY(-50%) rotate(0deg);
      width:18px;
      height:18px;
      border-top: 18px solid white;
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      pointer-events: none;
      // border-bottom: 0px solid transparent;
    }

    &.vs--open {
      &:after {
        top: 9px;
        transform: rotate(-180deg);
      }
    }

    .vs__actions {
      display: none;
    }

    .vs__selected {
      color: #fff;

      + input {
        display:none;
      }
    }

    .vs__search {
      color: #fff;
      font-size: 1.5rem;
      font-family: $font--base;
      font-weight: bold;
    }

    .vs__dropdown-menu {
      background: #000;
      color: #fff;
      opacity: 1;
      li {
        color: #fff;
      }
    }

    .vs__dropdown-option {
      &--highlight {
        background-color: grey;
      }
    }
  }

  @media screen and (max-width: $mobile) {
    &__select {
      width:100%;
      margin: 0 0 10px 0;
    }

    /deep/ .v-select {
      width: 100%;
      margin: 0px 0 10px 0;

      &:nth-child(3n) {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
